import axiosInterceptor from '../interceptor/axiosClient';
import { GetPriorArtPayload, PriorArtI } from './types';

export const getPriorArt = async (payload: GetPriorArtPayload): Promise<PriorArtI> => {
  const url =
    payload.pageNum != null
      ? `invention-disclosure/prior-art/${payload.inventionDisclosureId}?pageNum=${payload.pageNum - 1}`
      : `invention-disclosure/prior-art/${payload.inventionDisclosureId}`;
  const { data } = await axiosInterceptor.post<PriorArtI>(url, {});

  return data;
};
